<template>
  <a-modal v-bind:open="this.showModal"
           width="800px"
           :closable="true"
           :footer="null"
           :mask-closable="false"
           :mask-style="{backdropFilter: 'blur(2px)'}"
           :keyboard="false"
           @cancel="uiHandler.closeModal"
  >
    <div style="padding: 50px 10px 20px 10px">
      <a-table class="ant-table-striped"
               bordered
               size="small"
               :loading="dataLoading"
               :columns="card.columns"
               :data-source="processedDataSource"
               :pagination="false"
      >
        <template #emptyText>
          <div class="noData">
            <i class="fa-solid fa-exclamation-triangle" style="font-size: 24px; margin-bottom: 10px"/><br>
            <span>결제카드 등록을 요청해 주세요.</span>
          </div>
        </template>
      </a-table>
    </div>
  </a-modal>
</template>
<script>
import {styles} from "@/views/Subscriptions/styles";
import salesRecordApi from "@/views/Subscriptions/api";
import {oneBtnDialog} from "@/utils/utils";

const readOnly = {
  event: {
    CloseModal: "CloseModal"
  },
}

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false
    },
    dataSource: {
      type: Array,
      required: true,
      default: () => []
    },
  },
  computed: {
    processedDataSource() {
      return this.dataSource.map((d, idx) => {
        return {...d, no: idx + 1}
      })
    }
  },
  data() {
    return {
      uiHandler: this.ui(),
      apiHandler: this.api(),
      dataLoading: false,
      card: {
        columns: [
          {key: 'no', title: '회차', dataIndex: 'no', align: 'center', width: 40},
          {key: 'cardCompany', title: '카드회사', dataIndex: 'cardCompany', align: 'center'},
          {key: 'validDate', title: '유효기간', dataIndex: 'validDate', align: 'center'},
          {
            key: 'currentPaymentCard', title: '상태', dataIndex: 'currentPaymentCard', align: 'center',
            customRender: ({text, record}) => {
              let tagColor;
              if (text === '사용중') {
                tagColor = styles.tags.green
              } else if (text === '사용가능') {
                tagColor = styles.tags.blue
              } else if (text === '사용불가') {
                tagColor = styles.tags.red
              } else if (text === '등록필요') {
                tagColor = styles.tags.red
              }
              return (
                  <a-row style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <a-tag style={{...styles.tags.statusTag, ...tagColor}}>{text}</a-tag>
                  </a-row>
              )
            }
          },
          {
            key: 'check', title: '유효성검사', dataIndex: 'check', align: 'center',
            customRender: ({text, record}) => {
              if (!record.canUseCard) {
                return '-'
              } else {
                return (
                    <a-row style={{justify: "flex", justifyContent: 'center', alignItems: 'center'}}>
                      <a-button style={{height: '10px'}} onClick={async e => {
                        await this.uiHandler.authorizationCard(record._id)
                      }}>검사하기
                      </a-button>
                    </a-row>
                )
              }
            }
          }
        ]
      }
    }
  },
  methods: {
    ui() {
      return {
        authorizationCard: async (cardId) => {
          this.dataLoading = true
          await this.apiHandler.authorizationCard(cardId, async (response) => {
            if (response.data === 'ok') {
              await oneBtnDialog('안내', '카드정보가 유효합니다.')
            } else {
              await oneBtnDialog('안내', '카드정보가 유효하지 않습니다.')
            }
          }, async (error) => {
            await oneBtnDialog('검증실패', error.response.data.message)
          }).finally(() => this.dataLoading = false)
        },
        closeModal: () => {
          this.$emit(readOnly.event.CloseModal, {
            ModalStatus: false
          });
        }
      }
    },
    api() {
      return salesRecordApi(this.$apiInstance, this.$store)
    }
  }
}
</script>
<style scoped></style>